module.exports = __webpack_public_path__ + "img/business_slide3.4d5a70e8.png";